import { path } from 'ramda'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'
import history from '../history'
import ChannelTabs from './ChannelTabs'
import LoginPage from './LoginPage'
import PrivateRoute from './PrivateRoute'

class Routes extends Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <div>
                    <Switch>
                        <Route exact path="/login" component={LoginPage} />
                        <PrivateRoute
                            exact
                            path="/"
                            component={ChannelTabs}
                            isAuthenticated={this.props.isAuthenticated}
                        />
                    </Switch>
                </div>
            </ConnectedRouter>
        )
    }
}

const mapStateToProps = state => ({ isAuthenticated: path(['auth', 'token', 'access_token'], state) })

export default connect(mapStateToProps)(Routes)



// WEBPACK FOOTER //
// ./src/components/Routes.js